import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { login } from '@/api/homePage/api_login'
import { getSystemTime } from '@/api/api_commonController.js'
import { getMessagesNum } from '@/api/homePage/api_notification'
import {getUserAndMenuByToken, verifyToken} from '@/api/homePage/api_homePage'
import { Message } from 'element-ui'
import finance from './modules/finance.js'
import budget from './modules/budget.js'
import news from './modules/news.js'
import course from './modules/course.js'
import face from './modules/face.js'
import proFile from './modules/proFile.js'
import grow from './modules/grow.js'
// import BASEURL from '@/utils/ipConfig'

Vue.prototype.$message = Message
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    baseUrl: process.env.API_PAGE,
    baseUrlNews: process.env.API_PAGE_NEWS,
    dowloadUrl: process.env.API_DOWLOAD,
    filepathUrl: process.env.API_FILEPATH,
    newsMobileLink: process.env.API_NEWS_MOBILE_LINK,
    employeeInfo: {},
    systemMenu: [],
    // 当前菜单拥有的按钮权限
    buttonList: [],
    collapsed: false,
    // 消息通知页面 消息类型（1 系统消息，2 缴费通知）
    messagesType: 1,
    // 未读消息的数量
    MessagesNum: 0,
    // 服务器时间
    systemTime: '',
    // 对于 401错误 多次弹出，加一个开关进行控制
    isShowErrorMessageBox: true,
    token: localStorage.getItem('token') || ''
  },
  getters: {
    token: state => {
      return state.token
    }
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_USERINFO (state, employeeInfo) {
      state.employeeInfo = employeeInfo
    },
    SET_POSITIVENUM (state, total) {
      state.positiveTotal = total
    },
    SET_LEAVENUM (state, total) {
      state.leaveTotal = total
    },
    SET_SYSTEMMENU (state, systemMenu) {
      state.systemMenu = systemMenu
    },
    SET_SYSTEMTIME (state, systemTime) {
      state.systemTime = systemTime
    },
    // 左侧菜单开关，自定义大弹窗根据开关控制左侧left值
    SET_COLLAPSED (state, status) {
      state.collapsed = status
    },
    SET_MessagesNum (state, num) {
      state.MessagesNum = num
    },
    SET_messagesType (state, type) {
      state.messagesType = type
    },
    SET_isShowErrorMessageBox (state, flag) {
      state.isShowErrorMessageBox = flag
    },
    // 根据当前 路由，获取当前菜单的按钮权限
    SET_CURRENTBUTTON (state, curPath) {
      let menuList = store.state.systemMenu
      for (var i = 0; i < menuList.length; i++) {
        getMenuItem(menuList[i].children)
      }
      function getMenuItem (list) {
        for (let a = 0; a < list.length; a++) {
          if (curPath === list[a].menuUrl && list[a].menuType === 2) {
            // 菜单按钮存在的情况下，才赋值，不然split报错
            if (list[a].operation) {
              state.buttonList = list[a].operation.split(',')
            } else {
              state.buttonList = []
            }
            return false
          } else if (list[a].menuType === 1 && list[a].children.length > 0) {
            getMenuItem(list[a].children)
          }
        }
      }
    }

  },
  actions: {
    // 登录
    loginIn ({ commit }, params) {
      return new Promise((resolve, reject) => {
        // 登录接口
        login(params).then(res => {
          // if (payLoad.rememberPsw) {
          //   localStorage.setItem('username', payLoad.username)
          //   localStorage.setItem('password', payLoad.password)
          // }
          localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token)
          localStorage.setItem('loginType', params.loginType)
          commit('SET_TOKEN', res.data.token_type + ' ' + res.data.access_token)
          verifyToken(params.loginType).then(res => {
            getUserAndMenuByToken(params.loginType).then(res => {
              const menuList = res.systemMenu
              // 如果未配置权限，菜单为空，跳转到 提示页
              if ((Array.isArray(menuList) && menuList.length === 0) || menuList === null) {
                router.push('/errorNopermission')
              }
              let defaultUrl = ''
              getUrl(menuList)
              router.push({
                path: defaultUrl,
                query: {
                  firstLogin: true
                }
              })
              // 递归获取当前拥有权限的 默认菜单（第一级菜单下的第一条）
              function getUrl (item) {
                if (item[0].menuType === 2) {
                  defaultUrl = item[0].menuUrl
                  console.log(defaultUrl)
                  return item[0].menuUrl
                } else {
                  getUrl(item[0].children)
                }
              }
              resolve()
            })
          })
        }).catch(error => {
          if (error.response) {
            console.log(error.response)
            if (error.response.status === 400) {
              Message({
                type: 'error',
                message: error.response.data.msg
              })
            } else if (error.response.status === 401) {
              Message({
                type: 'error',
                message: '用户名或密码错误'
              })
            }
          }
        })
        resolve()
      })
    },
    // 获取人员离职和转正员工
    // isHavePermission ({ commit }, status) {
    //   return new Promise((resolve, reject) => {
    //     employeeInfoList({state: status}).then(res => {
    //       if (status === 2) {
    //         commit('SET_POSITIVENUM', res.total)
    //       } else if (status === 3) {
    //         commit('SET_LEAVENUM', res.total)
    //       }
    //     })
    //     resolve()
    //   })
    // },
    // 获取服务器时间
    getSystemTime ({ commit }) {
      return new Promise((resolve, reject) => {
        getSystemTime().then(res => {
          commit('SET_SYSTEMTIME', res)
          resolve(res)
        })
      })
    },
    // 注销
    LogOut () {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        // localStorage.removeItem('username')
        // localStorage.removeItem('password')
        router.push('/login')
        // 添加退出日志
        // systemUserExitLogin(this.getters.token, this.getters.token.split(' ')[1]).then(res => {
        // })
        resolve()
      })
    },
    // 查询收件箱 未读信息数量
    getMessagesNum ({ commit }) {
      return new Promise((resolve, reject) => {
        getMessagesNum().then(res => {
          if (this.state.messagesType === 1) {
            // 系统消息
            commit('SET_MessagesNum', res.systemMessageNum)
          } else if (this.state.messagesType === 2) {
            // 缴费通知
            commit('SET_MessagesNum', res.paymentNoticeNum)
          }
        })
        resolve()
      })
    }
    // addRoutes ({commit, state}) {
    //   return new Promise(resolve => {
    //     verifyToken().then(res => {
    //       getUserAndMenuByToken().then(res => {
    //         const menuList = res.systemMenu
    //         // 如果未配置权限，菜单为空，跳转到 提示页
    //         if (!(Array.isArray(menuList) && menuList.length > 0)) {
    //           this.$router.push('/errorNopermission')
    //         }
    //         let defaultUrl = ''
    //         getUrl(menuList)
    //         router.push({
    //           path: defaultUrl,
    //           query: {
    //             firstLogin: true
    //           }
    //         })
    //         // 递归获取当前拥有权限的 默认菜单（第一级菜单下的第一条）
    //         function getUrl (item) {
    //           if (item[0].menuType === 2) {
    //             defaultUrl = item[0].menuUrl
    //             console.log(defaultUrl)
    //             return item[0].menuUrl
    //           } else {
    //             getUrl(item[0].children)
    //           }
    //         }
    //         resolve()
    //       })
    //     })
    //   })
    // }
  },
  modules: {
    finance,
    budget,
    news,
    course,
    grow,
    face,
    proFile
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js